import React from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, TextStyled, HeadingStyled, SpanStyled } from '../../../ui/Elements'
import { BannerImg, HeroBg, HeroBgAr, HeroBgRes } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
const Banner = () => {
    const { t } = useTranslation()
    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid' id='banner'>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} lg={6} xl={5} className="pb-5 bannerCol1">
                            <MainHeading className='main-heading mb-3' size="70px" color="var(--white)" lh="1.1">{t('wemovefurniture')}</MainHeading>
                            <HeadingStyled className='bannerSubTxt mb-2' transform="uppercase" color="var(--white)" lh="1.4">
                                {t('whatwedid')}
                            </HeadingStyled>
                            <SpanStyled className='bannerSubDetailTxt' color="var(--white)" size="18px" lh="1.4">
                                {t('bannerDetailTxt')}
                            </SpanStyled>
                        </Col>
                        <Col md={12} lg={6} xl={7} className="d-flex justify-content-end bannerImgContainer">
                            <LazyImage src={BannerImg} />
                        </Col>
                    </Box>
                </Container>
            </BannerWapper>
        </>
    )
}
const BannerWapper = styled.section`
    padding-bottom: 0;
    background-image: url(${HeroBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 590px;
    padding-top: 100px;
    .bannerRow{
        padding: 0px 0px 0 60px;
        align-items: center;
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    body.rtl &{
        background-image: url(${HeroBgAr});
        .bannerRow{
            padding: 0px 60px 0 0px;
            align-items: center;
        }
        .main-heading{
            font-size: 60px;
        }
        .bannerCol1{
            padding-bottom: 60px !important;
        }
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        .main-heading{
            font-size: 55px;
        }
    }
    @media (max-width: 991px) {
        background-image: url(${HeroBgRes}) !important;
        height: auto;
        .main-heading{
            font-size: 45px;
            text-align: center;
        }
        .bannerSubTxt{
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .bannerSubDetailTxt{
            text-align: center;
            display: inline-block;
        }
        .bannerImgContainer{
            justify-content: center !important;
            padding-top: 0px;
        }
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        body.rtl &{
            background-image: url(${HeroBgAr});
            .main-heading{
                font-size: 40px;
            }
            .bannerCol1{
                padding-bottom: 30px !important;
            }
            .bannerSubTxt{
                font-size: 26px;
            }
        }
    }
    @media (max-width: 640px) {
        padding-top: 80px;
        body.rtl &{
            .main-heading{
                font-size: 35px;
            }
            .bannerSubTxt{
                font-size: 24px;
            }
        }
    }
`
export default Banner
